import { render, staticRenderFns } from "./zhuxiao.vue?vue&type=template&id=cd4f4ece"
import script from "./zhuxiao.vue?vue&type=script&lang=js"
export * from "./zhuxiao.vue?vue&type=script&lang=js"
import style0 from "./zhuxiao.vue?vue&type=style&index=0&id=cd4f4ece&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports